var blockBundles;

try {
  blockBundles = {
    jx1_sinhnhat_19nam: {
      content: {
        header: {
          html: require("../../jx1_sinhnhat_19nam/header/header.html.twig"),
          scss: require("../../jx1_sinhnhat_19nam/header/header.scss"),
          js: require("../../jx1_sinhnhat_19nam/header/header.js"),
          dir: "jx1_sinhnhat_19nam/header/header",
        },
        vongquay: {
          html: require("../../jx1_sinhnhat_19nam/vongquay/vongquay.html.twig"),
          scss: require("../../jx1_sinhnhat_19nam/vongquay/vongquay.scss"),
          js: require("../../jx1_sinhnhat_19nam/vongquay/vongquay.js"),
          dir: "jx1_sinhnhat_19nam/vongquay/vongquay",
        },
        required_popup: {
          html: require("../../jx1_sinhnhat_19nam/required_popup/required_popup.html.twig"),
          scss: require("../../jx1_sinhnhat_19nam/required_popup/required_popup.scss"),
          js: require("../../jx1_sinhnhat_19nam/required_popup/required_popup.js"),
          dir: "jx1_sinhnhat_19nam/required_popup/required_popup",
        },
      },

      float: {
        float_top: {
          html: require("../../jx1_sinhnhat_19nam/float_top/float_top.html.twig"),
          scss: require("../../jx1_sinhnhat_19nam/float_top/float_top.scss"),
          js: require("../../jx1_sinhnhat_19nam/float_top/float_top.js"),
          dir: "jx1_sinhnhat_19nam/float_top/float_top",
        },
      },
    },
    common: {
      required: {
        required_loading: {
          html: require("../../common/required_loading/required_loading.html.twig"),
          scss: require("../../common/required_loading/required_loading.scss"),
          js: require("../../common/required_loading/required_loading.js"),
          dir: "common/required_loading/required_loading",
        },
      },
    },
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;
